import { Stack } from "@mui/material";

import { SelectableBox } from "../../../components/SelectableBox";

interface Option {
  value: string;
  label: string;
}

interface MultiSelectQuestionProps {
  options: Option[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  noneValue?: string;
}

export function MultiSelectQuestion(props: MultiSelectQuestionProps) {
  const { options, selectedValues, onChange, noneValue = "NONE" } = props;

  function handleSelect(optionValue: string) {
    if (optionValue === noneValue) {
      onChange(selectedValues.includes(noneValue) ? [] : [noneValue]);
      return;
    }

    const withoutNone = selectedValues.filter((v) => v !== noneValue);
    if (withoutNone.includes(optionValue)) {
      onChange(withoutNone.filter((v) => v !== optionValue));
    } else {
      onChange([...withoutNone, optionValue]);
    }
  }

  return (
    <Stack spacing={4}>
      {options.map((option) => (
        <SelectableBox
          key={option.value}
          isSelected={selectedValues.includes(option.value)}
          sx={(theme) => ({
            boxShadow: "none",
            border: 1,
            borderColor: theme.palette.border?.primary,
          })}
          onToggleSelect={() => {
            handleSelect(option.value);
          }}
        >
          {option.label}
        </SelectableBox>
      ))}
    </Stack>
  );
}
